$(document).ready(function(){

  $('.header__icons-item-link.flag').on('click', function(e){
    e.preventDefault();
    $('.country-selector-wrapper').addClass('show');
  });

  $(document).mouseup(function (e){

    var container = $(".country-selector-content");

    if (!container.is(e.target) && container.has(e.target).length === 0){

      container.parent('.country-selector-wrapper').removeClass('show');

    }
  });

  //country options
  var $currentPath = window.location.pathname;
  $('.country-selector-options option').each(function(){
    $(this).attr('value',$(this).attr('value')+$currentPath);
  })
  $('.country-selector-options').change(function(){
    var country = $(this).val();
    $('.csc-footer a').attr('href', country);
  });

  $('.csc-footer a').on('click', function (){
    console.log('clickkk')
  })
});